import { Injectable } from '@angular/core';
import { SpeechProperties } from '../model/speech.interface';

@Injectable({
  providedIn: 'root',
})
export class SpeechService {
  private voices: SpeechSynthesisVoice[] = [];

  updateSpeech(property: SpeechProperties): void {
    const { name, value } = property;
    localStorage.setItem(name, value);
    this.toggle();
  }

  setVoices(voices: SpeechSynthesisVoice[]): void {
    this.voices = voices;
  }

  updateVoice(voiceName: string): void {
    localStorage.setItem('voice', voiceName);
  }

  private findVoice(voiceName: string): SpeechSynthesisVoice | null {
    const voice = this.voices.find((v) => v.name === voiceName);
    return voice ? voice : null;
  }

  toggle(startOver = true): void {
    const speech = this.makeRequest();
    speechSynthesis.cancel();
    if (startOver) {
      speechSynthesis.speak(speech);
    }
  }

  private makeRequest(): SpeechSynthesisUtterance {
    const speech = new SpeechSynthesisUtterance();
    speech.text = localStorage.getItem('text') || '';
    speech.rate = +('1');
    speech.pitch = +('1');
    const voice = this.findVoice(localStorage.getItem('voice') || '');
    if (voice) {
      speech.voice = voice;
    }
    return speech;
  }

  allVoicesCode() {
    return [
      { "labels": ["bahrain", "bahreïn", "arabic", "arabe"], "value": "ar-BH" },
      // { "labels": ["brazil", "brésil", "portuguese", "portugais"], "value": "pt-BR" },
      { "labels": ["bulgaria", "bulgarie", "bulgarian", "bulgare"], "value": "bg-BG" },
      { "labels": ["china (simp.)", "chine (simplifié)", "chinese mandarin", "mandarin"], "value": "cmn-Hans-CN" },
      { "labels": ["croatia", "croatie", "croatian", "croate"], "value": "hr-HR" },
      { "labels": ["czech republic", "république tchèque", "czech", "tchèque"], "value": "cs-CZ" },
      { "labels": ["denmark", "danemark", "danish", "danois"], "value": "da-DK" },
      { "labels": ["egypt", "égypte", "arabic", "arabe"], "value": "ar-EG" },
      { "labels": ["finland", "finlande", "finnish", "finnois"], "value": "fi-FI" },
      { "labels": ["france", "france", "french", "français"], "value": "fr-FR" },
      { "labels": ["germany", "allemagne", "german", "allemand"], "value": "de-DE" },
      { "labels": ["greece", "grèce", "greek", "grec"], "value": "el-GR" },
      { "labels": ["hong kong sar (trad.)", "hong kong (traditionnel)", "chinese mandarin", "mandarin"], "value": "cmn-Hans-HK" },
      { "labels": ["hungary", "hongrie", "hungarian", "hongrois"], "value": "hu-HU" },
      { "labels": ["iceland", "islande", "icelandic", "islandais"], "value": "is-IS" },
      { "labels": ["india", "inde", "hindi", "hindi"], "value": "hi-IN" },
      { "labels": ["indonesia", "indonésie", "indonesian", "indonésien"], "value": "id-ID" },
      { "labels": ["iran", "iran", "farsi", "persan"], "value": "fa-IR" },
      { "labels": ["iraq", "irak", "arabic", "arabe"], "value": "ar-IQ" },
      { "labels": ["israel", "israël", "arabic", "arabe"], "value": "ar-IL" },
      { "labels": ["israel", "israël", "hebrew", "hébreu"], "value": "he-IL" },
      { "labels": ["italy", "italie", "italian", "italien"], "value": "it-IT" },
      { "labels": ["japan", "japon", "japanese", "japonais"], "value": "ja-JP" },
      { "labels": ["jordan", "jordanie", "arabic", "arabe"], "value": "ar-JO" },
      { "labels": ["kuwait", "koweït", "arabic", "arabe"], "value": "ar-KW" },
      { "labels": ["lebanon", "liban", "arabic", "arabe"], "value": "ar-LB" },
      { "labels": ["lithuania", "lituanie", "lithuanian", "lituanien"], "value": "lt-LT" },
      { "labels": ["malaysia", "malaisie", "malaysian", "malaisien"], "value": "ms-MY" },
      { "labels": ["morocco", "maroc", "arabic", "arabe"], "value": "ar-MA" },
      { "labels": ["netherlands", "pays-bas", "dutch", "néerlandais"], "value": "nl-NL" },
      { "labels": ["norway", "norvège", "norwegian", "norvégien"], "value": "no-NO" },
      { "labels": ["oman", "oman", "arabic", "arabe"], "value": "ar-OM" },
      { "labels": ["palestinian territory", "territoire palestinien", "arabic", "arabe"], "value": "ar-PS" },
      { "labels": ["philippines", "philippines", "filipino", "filipino"], "value": "fil-PH" },
      { "labels": ["poland", "pologne", "polish", "polonais"], "value": "pl-PL" },
      { "labels": ["portugal", "portugal", "portuguese", "portugais"], "value": "pt-PT" },
      { "labels": ["qatar", "qatar", "arabic", "arabe"], "value": "ar-QA" },
      { "labels": ["romania", "roumanie", "romanian", "roumain"], "value": "ro-RO" },
      { "labels": ["russia", "russie", "russian", "russe"], "value": "ru-RU" },
      { "labels": ["saudi arabia", "arabie saoudite", "arabic", "arabe"], "value": "ar-SA" },
      { "labels": ["slovakia", "slovaquie", "slovak", "slovaque"], "value": "sk-SK" },
      { "labels": ["slovenia", "slovénie", "slovenian", "slovène"], "value": "sl-SI" },
      { "labels": ["south africa", "afrique du sud", "afrikaans"], "value": "af-ZA" },
      { "labels": ["spain", "espagne", "basque", "basque"], "value": "eu-ES" },
      { "labels": ["spain", "espagne", "catalan", "catalan"], "value": "ca-ES" },
      { "labels": ["spain", "espagne", "galician", "galicien"], "value": "gl-ES" },
      { "labels": ["switzerland", "suisse", "italian", "italien"], "value": "it-CH" },
      { "labels": ["taiwan (trad.)", "taïwan (traditionnel)", "chinese mandarin", "mandarin"], "value": "cmn-Hant-TW" },
      { "labels": ["tunisia", "tunisie", "arabic", "arabe"], "value": "ar-TN" },
      { "labels": ["united arab emirates", "émirats arabes unis", "arabic", "arabe"], "value": "ar-AE" },
      { "labels": ["united states", "états-unis", "english", "anglais"], "value": "en-US" }
    ];
  }
}
